import { isLocale, LOCALES } from '@porotutu/i18n'
import { LanguagesIcon } from 'lucide-react'
import { useSession, useT } from '@/session/useSession'
import { IconButton } from '../IconButton/IconButton'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'

export function LocaleToggle() {
  const t = useT()
  const { locale, setLocale } = useSession()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <IconButton label={t('language.legend')}>
            <LanguagesIcon />
          </IconButton>
        }
      />
      <DropdownMenuContent align="end">
        <DropdownMenuRadioGroup
          value={locale}
          onValueChange={(next) => {
            if (isLocale(next)) setLocale(next)
          }}
        >
          {LOCALES.map((option) => (
            <DropdownMenuRadioItem key={option} value={option}>
              {t(`language.${option}.name`)}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
